export default __webpack_public_path__ + "static/media/message-icon.22feeec2.svg";